import React from 'react';
import { useSelector } from 'react-redux';
import { BlockedReason, ResultStage, ValidationIssue } from 'api/StudentLoanApi';
import FormNavigation from 'components/FormNavigation';
import FormContainer from 'components/LoanForm/FormContainer';
import Button from 'components/Button';
import { ButtonType } from 'components/Button/Button';
import StudentLoanLoaderWrapper from 'components/StudentLoanForgiveness/LoaderWrapper';
import { InfoNote, StepList } from 'components/StudentLoanForgiveness/Common/ResultBlocks';
import { getFindingCopy, getStepCopy } from 'components/StudentLoanForgiveness/studentLoanCopy';
import { BlockedScreenResult } from 'enums/StudentLoanForgivenessFlowResults';
import { FlowComponentType } from 'routes/types';
import { getStudentLoanData } from 'selectors/getStudentLoanData';

import commonStyles from 'components/StudentLoanForgiveness/Common/Common.module.scss';

const titles: Record<BlockedReason, string> = {
  [BlockedReason.Default]: "We can't build a plan yet",
  [BlockedReason.InvalidFile]: "We couldn't read your file",
};

const getErrorMessages = (issues: ValidationIssue[]) =>
  issues.filter(({ severity }) => severity === 'error').map(({ message }) => message);

const Blocked = ({ navigationInfo, handleNext }: FlowComponentType) => {
  const { result } = useSelector(getStudentLoanData);
  const blocked = result?.stage === ResultStage.Blocked ? result : undefined;

  return (
    <StudentLoanLoaderWrapper>
      <>
        <FormNavigation {...navigationInfo} />
        {blocked && (
          <FormContainer title={titles[blocked.reason]}>
            {blocked.findings.map((finding) => (
              <InfoNote key={finding.code} {...getFindingCopy(finding)} />
            ))}

            {getErrorMessages(blocked.issues).map((message) => (
              <InfoNote key={message} title="" body={message} />
            ))}

            <StepList steps={blocked.steps.map((step) => getStepCopy(step))} />

            <div className={commonStyles.buttons}>
              {blocked.reason === BlockedReason.InvalidFile && (
                <Button onClick={() => handleNext(BlockedScreenResult.UploadNewFile)}>Upload a new file</Button>
              )}
              <Button
                type={blocked.reason === BlockedReason.InvalidFile ? ButtonType.Transparent : ButtonType.Primary}
                onClick={() => handleNext(BlockedScreenResult.Done)}
              >
                Done
              </Button>
            </div>
          </FormContainer>
        )}
      </>
    </StudentLoanLoaderWrapper>
  );
};

export default Blocked;
